import '@babel/polyfill';

(async () => {
  await import(/* webpackChunkName: "silo-by-location-main" */ '../pages/silo/main');
})();
